import React, { useState, useEffect, useRef } from 'react'
import styled, { css } from 'styled-components'
import { useMutation } from '@apollo/client'
import { useQuery } from '@apollo/client'
import { useParams, useNavigate } from 'react-router'
import Select from 'react-select'

import { navy, backgroundGray } from '../../layout/colors'
import TextInput from '../../layout/textInput'
import { InputValueStateType } from '../../constants/types'
import foods from '../../queries/v2/foods'
import LoaderSpinner from '../../layout/loader'
import addCanteenOffer from '../../mutations/v2/addCanteenOffer'
import { customStyles } from '../editUser/Main'
import FormInfoText from '../../layout/FormInfoText'
import canteen from 'src/queries/v2/canteen'
import { routes } from 'src/constants/routes'
import Button from 'src/components/Button'

const AddOffer = () => {
  const ref = useRef<HTMLButtonElement>(null)
  const [submitButtonInactive, setSubmitButtonInactive] = useState(true)
  const [err, setError] = useState(false)
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()

  const foodOffer = useQuery(foods, {
    variables: { canteenId: parseInt(id!) },
  })

  const [formState, setFormState] = useState<InputValueStateType>({
    date: { value: '', isInvalid: false },
    food: { value: '', isInvalid: false },
  })

  const refetchQueries = {
    refetchQueries: [
      {
        query: canteen,
        variables: { id: parseInt(id!) },
      },
    ],
  }
  const [reg] = useMutation(addCanteenOffer, {
    ...refetchQueries,
    onCompleted() {
      navigate(routes.canteenDetail(id!))
    },
  })

  function handleSubmit() {
    if (formState.date.isInvalid || formState.food.isInvalid) {
      return setError(true)
    }
    const data = {
      canteenId: parseInt(id!),
      date: formState.date.value,
      foodId: parseInt(formState.food.value),
    }
    setError(false)
    return reg({ variables: { data } })
  }

  useEffect(() => {
    if (formState.date.isInvalid || formState.food.isInvalid) setSubmitButtonInactive(true)
    else setSubmitButtonInactive(false)
  }, [formState])

  function handleValidation(value: string) {
    return !/^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/.test(value)
  }

  function handleEnter(event: any) {
    if (event.keyCode === 13 && ref && ref.current) {
      event.preventDefault()
      ref.current.click()
    }
  }

  useEffect(() => {
    window.addEventListener('keyup', handleEnter)

    return () => {
      window.removeEventListener('keyup', handleEnter)
    }
  }, [])

  function selectOnChange(e?: any) {
    setFormState({
      ...formState,
      food: {
        value: e ? e.value : '1',
        isInvalid: false,
      },
    })
  }

  if (foodOffer.loading) {
    return <LoaderSpinner />
  }

  const options =
    foodOffer?.data?.foods.map((food) => ({
      value: food.id,
      label: food.name,
    })) ?? []

  return (
    <Container100vh>
      <Container>
        <Form>
          <Heading>Přidání nové nabídky</Heading>
          <TextInput
            type="date"
            placeholder="Datum"
            value={formState.date.value}
            isInvalid={formState.date.isInvalid}
            onChange={(e) =>
              setFormState({
                ...formState,
                date: {
                  value: e.target.value,
                  isInvalid: handleValidation(e.target.value),
                },
              })
            }
          />
          <Select
            isSearchable={true}
            styles={customStyles}
            options={options}
            value={options.find((obj) => obj.value.toString() === formState.food.value)}
            //isInvalid={formState.rights.isInvalid}
            onChange={(e) => selectOnChange(e)}
            placeholder={'Vyberte pokrm'}
            noOptionsMessage={() => 'Žádný pokrm nenalezen'}
          />
          <div>{err && <LoginError>Neplatná data</LoginError>}</div>
          <Button ref={ref} disabled={submitButtonInactive} onClick={handleSubmit}>
            Přidat nabídku
          </Button>
          <FormInfoText linkText={'Zpět'} href={routes.canteenDetail(id!)} />
        </Form>
      </Container>
    </Container100vh>
  )
}

export default AddOffer

const Container100vh = styled.div`
  min-height: calc(100vh - 208.88px);

  display: flex;
  justify-content: center;
  align-items: center;

  background: url('/img/pattern_modry.svg'), ${navy};
  background-attachment: fixed;
  background-attachment: fixed;
  background-position: center;
  background-size: 730px;

  @media (min-width: 366px) {
    min-height: calc(100vh - 219.88px);
  }
`

const Container = styled.div`
  flex: 1;
  padding: 30px 0;
  height: 100%;
`

const Form = styled.div`
  width: 80%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  padding: 20px 20px 50px 20px;
  box-shadow: 0rem 0.5rem 2rem rgb(0 0 0 / 20%);
  border-radius: 5px;
  background-color: white;

  @media (min-width: 500px) {
    padding: 20px 50px 50px 50px;
    width: 70%;
  }

  @media (min-width: 600px) {
    width: 50%;
  }

  @media (min-width: 900px) {
    width: 30%;
  }

  @media (min-width: 2000px) {
    width: 20%;
  }

  @media (min-width: 3000px) {
    width: 15%;
  }
`

const Heading = styled.h2`
  text-align: center;
`

const LoginError = styled.span`
  color: #fc6969;
  font-weight: 500;
  font-size: 0.81em;
  position: absolute;
  margin-bottom: 0.75em;
  margin-top: -0.8em;
  display: flex;
  justify-content: flex-start;
`
